import { NgModule, ModuleWithProviders, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { MmAlertModule } from '@metromarkets/components';

import { HttpErrorInterceptor } from './interceptors/http-error.interceptor';
import { ErrorHandlerConfigToken } from './tokens/error-handler-config.token';
import { ErrorHandlerConfig } from './models/error-handler-config.interface';
import { MainErrorHandler } from './services/error-handler.service';
import { HttpErrorHandler } from './services/http-error-handler.service';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MmAlertModule,
  ],
})
export class ErrorHandlerModule {
  public static forRoot(configFactory: () => ErrorHandlerConfig): ModuleWithProviders<ErrorHandlerModule> {
    return {
      ngModule: ErrorHandlerModule,
      providers: [
        HttpErrorHandler,
        { provide: ErrorHandler, useClass: MainErrorHandler},
        { provide: ErrorHandlerConfigToken, useFactory: configFactory },
        { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
      ]
    };
  }
}
